export default __webpack_public_path__ + "static/scroll_phone_2-de42e7e54b4b15967e1c4612a30124c5.png";